import TransformComponent from '../../../Component/Transform';
import { Easing } from '@tweenjs/tween.js';
import AnimationClip from '../AnimationClip';
import CardSystem, { getCardHandler } from '../../Card/CardSystem';
import BaseCardHandler from '../../Card/Handler/BaseCardHandler';
import { PlaySound } from '../../Audio/AudioHelper';
import { AudioTrackType } from '../../Audio/AudioClip';
import BaseCard from '../../../Prototype/Level/Card/BaseCard';
import { DEFAULT_CARD_SCALE } from '../../../Component/Level/Card';
import CardComponent from 'Component/Level/Card';

interface ICardFoldMeta {
    system?: CardSystem;
}

export class CardFold extends AnimationClip<ICardFoldMeta> {
    public* execute(
        gameObject: BaseCard,
        meta: ICardFoldMeta = {},
    ): IterableIterator<number> {
        if (meta?.system) {
            PlaySound('cardreserve');
        }

        const transform: TransformComponent = gameObject.getComponent(
            TransformComponent,
        );
        const handler: BaseCardHandler = getCardHandler(gameObject);

        const tweenX = this.getTween(transform.position);
        tweenX
            .to(
                {
                    x: 0,
                    y: 0,
                },
                300,
            )
            .easing(Easing.Quadratic.InOut)
            .start(this.elapsedTime)
            .onComplete(() => {
                // Set to 0,0 + offset
                transform.position.set(0);
                transform.rotation = 0;
            });

        const tweenIn = this.getTween(transform.scale);
        tweenIn.to({ x: 0 }, 150).easing(Easing.Quadratic.In);

        yield* this.startTween(tweenIn);

        handler.setCardFaceUp(true);

        const tweenOut = this.getTween(transform.scale);
        tweenOut
            .to({ x: DEFAULT_CARD_SCALE }, 150)
            .easing(Easing.Quintic.Out);

        // Not yielded...
        yield* this.startTween(tweenOut);
    }
}
